const classNames = require('classnames');

const IconContent = ({
    icon,
    title,
    text,
    color,
    textColor,
    bigText,
    smallText,
    className,
}) => {

    const iconContentClass = classNames({
        'icon-content': true,
        [className]: className,
    });

    const iconClass = classNames({
        icon: true,
        [`icon-${icon}`]: true,
        [`bg-${color}`]: color && icon !== 'error-alt', // TODO: need improvement
        [`text-${color}`]: color && icon === 'error-alt', // TODO: need improvement
    });

    const bigTextClass = classNames({
        'icon-content__content__big-text': true,
        [`text-${color}`]: color,
    });

    const smallTextClass = classNames({
        'icon-content__content__small-text': true,
        [`text-${color}`]: color,
    });

    const textClass = classNames({
        'icon-content__content__description': true,
        [`text-${textColor}`]: textColor,
    });

    const titleClass = classNames({
        'icon-content__content__title': true,
        [`text-${textColor}`]: textColor,
    });


    return <div className={iconContentClass}>
        {icon && <div className="icon-content__icon mr-2">
            <span className={iconClass} />
        </div>}
        <div className="icon-content__content">
            {title && <div className={titleClass} dangerouslySetInnerHTML={{ __html: title }} />}
            {text &&
                <div className={textClass} dangerouslySetInnerHTML={{ __html: text }} />}
            {bigText &&
                <div className={bigTextClass} dangerouslySetInnerHTML={{ __html: bigText }} />}
            {smallText &&
                <div className={smallTextClass} dangerouslySetInnerHTML={{ __html: smallText }} />}
        </div>
    </div>;
};

export default IconContent;
